<template>
    <div class="nav" :class="{ 'nav-small' : this.$route.name === 'Solution' }">
        <router-link class="nav-logo-link" to="/">
            <img class="nav-logo" src="/static/img/logo.svg" alt="cDots" :class="{ 'nav-logo-small' : this.$route.name === 'Solution' }">
        </router-link>
        <section class="nav-wrap"  :class="{ 
          'nav-wrap--light' : this.$route.name === 'Contacts'
        }">
          <ul class="nav-ul">
            <li class="nav-li">
                <a class="nav-item" @click="goToSolutions()">ПРОГРАМИ</a>
            </li>
            <li class="nav-li">
                <router-link class="nav-item" active-class="nav-item-active" to="/about">ЗА НАС</router-link>
            </li>
            <li class="nav-li">
                <router-link class="nav-item" active-class="nav-item-active" to="/contacts">КОНТАКТИ</router-link>
            </li>
            <li class="nav-li">
                <router-link class="nav-item" active-class="nav-item-active" to="/services">УСЛУГИ</router-link>
            </li>
             <li class="nav-li">
                <router-link class="nav-item" active-class="nav-item-active" to="/clients">КЛИЕНТИ</router-link>
            </li>
          </ul>

          <div id="google_translate_element"></div>
            </section>
    </div>
</template>

<script>
export default {
  methods: {
    goToSolutions() {
      const solutionsEl = document.getElementById("solutions");
      if (this.$route.name === 'Home') {
        window.scrollTo({
          top: solutionsEl.offsetTop,
          behavior: "smooth"
        });
      } else {
        this.$router.push("/");
      }
    }
  }
};
</script>

<style>
.nav {
  align-items: center;
  display: flex;
  height: 145px;
  justify-content: space-between;
  padding: 25px 100px;
  position: relative;
  z-index: 10;
}
.nav-logo-link {
  display: flex;
}
.nav-logo {
  width: 275px;
}
.nav-wrap {
  align-items: center;
  display: flex;
  gap: 5px;
}
.nav-wrap--light .nav-item,
.nav-wrap--light .menu-text,
.nav-wrap--light .goog-te-gadget,
.nav-wrap--light .goog-te-gadget a {
  color: #fff;
}

.goog-te-gadget {
  bottom: 10px;
  font-family: 'Google Sans' !important;
  position: fixed;
  right: 10px;
}

#google_translate_element select {
  background: #0e161a;
  color: #fff;
  border: 1px solid #555;
  padding: 5px 10px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 5px;
  width: 150px;
}

.website-translator {
  padding: initial;
}
.nav-ul {
  list-style: none;
}
.nav-li {
  display: inline-block;
  margin-left: 45px;
}
.nav-item {
  color: #0e161a;
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
}
.nav-item:hover {
  text-decoration: underline;
}
.nav-item-active {
  text-decoration: underline;
}
.nav-small {
  height: 100px;
}
.nav-logo-small {
  width: 168px;
}
/* RESPONSIVE */
@media screen and (max-width: 1600px) {
  .nav-item {
    font-size: 16px;
  }
}
@media screen and (max-width: 1440px) {
  .nav {
    height: 100px;
  }
  .nav-logo {
    width: 180px;
  }
  .nav-li {
    margin-left: 30px;
  }
  .nav-item {
    font-size: 14px;
  }
}
@media screen and (max-width: 1280px) {
  .nav-wrap--light .nav-item, .nav-wrap--light .menu-text {
    color: #0e161a;
  }
}
@media screen and (max-width: 1000px) {
  .nav {
    justify-content: center;
    padding: 0;
  }
  .goog-te-gadget {
    bottom: 75px;
  }
  .nav-ul {
    align-items: center;
    background-color: #fff;
    bottom: 0;
    box-shadow: 0px -1px 6px 0 rgba(0, 0, 0, 0.16);
    display: flex;
    height: 63px;
    justify-content: space-around;
    position: fixed;
    width: 100%;
    left: 0;
    min-width: 320px;
  }
  .nav-li {
    margin: 0;
  }
}
@media screen and (max-width: 600px) {
  .nav-ul {
    height: 50px;
  }
  .nav-item {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Nav.vue